export default "__VITE_PUBLIC_ASSET__1d974ca3__"